import { render, staticRenderFns } from "./LoanTakeBackConfirm.vue?vue&type=template&id=5c2c650a&scoped=true&"
import script from "./LoanTakeBackConfirm.vue?vue&type=script&lang=ts&"
export * from "./LoanTakeBackConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2c650a",
  null
  
)

export default component.exports